module.exports = __webpack_public_path__ + "media/images/symbols/black-caret-right-1d201d3cca6af101507cdebb94b02df0.svg";